export const WileyColors = {
  blue: {
    dark: "#123D80",
    medium: "#1B5BA0",
    bright: "#18B7FB",
  },
  green: {
    dark: "#115C36",
    medium: "#198C53",
    bright: "#18C76F",
  },
  berry: {
    dark: "#941E66",
    medium: "#B92D80",
    bright: "#FF91AA",
  },
  yellow: {
    dark: "#D66310",
    medium: "#EB850D",
    bright: "#FFC805",
  },
};

export const colors = {
  black: "#000000",
  white: "#ffffff",
  grey: {
    50: "#FAFAFA",
    100: "#F5F5F5",
    200: "#EAEAEA",
    300: "#D6D6D6",
    400: "#ADADAD",
    500: "#9E9E9E",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
  },
  blue: {
    50: "#D8F0FA", // ReX light Blue
    100: "#8CC8EE",
    200: "#4BA1DC",
    300: "#2B7EC3",
    400: WileyColors.blue.medium,
    500: WileyColors.blue.dark,
    600: "#0B2760",
    700: "#071943",
    800: "#040E28",
    900: "#020613",
  },
  lightBlue: {
    50: "#ADE6FF",
    100: "#71D4FF",
    150: "#7FD2EE",
    200: "#47C7FF",
    300: "#2ABEFD",
    400: WileyColors.blue.bright,
    500: "#10B0F4",
    600: "#0AA4E6",
    700: "#058BC4",
    800: "#02628B",
    900: "#003248",
  },
  green: {
    50: "#E8FFF2", // ReX light green
    100: "#C2F9DB",
    200: "#84E6B2",
    300: "#4DC185",
    400: "#288F5C",
    500: WileyColors.green.dark,
    600: "#06351E",
    700: "#022112",
    800: "#01140B",
    900: "#000805",
  },
  orange: {
    50: "#FFF0E8", // ReX light orange
    100: "#FAD8C6",
    200: "#F5B58F",
    300: "#ED7632",
    400: "#DE5A08",
    500: "#CC4E00", // ReX main orange
    600: "#B44800",
    700: "#973C00",
    800: "#742E00",
    900: "#3D1800",
  },
  pink: {
    50: "#FFD6DA",
    100: "#FFB3BF",
    200: WileyColors.berry.bright,
    300: "#F96FA4",
    400: "#E24B98",
    500: WileyColors.berry.medium,
    600: WileyColors.berry.dark,
    700: "#70134E",
    800: "#4E0A38",
    900: "#200218",
  },
  red: {
    50: "#FFE8E8", // ReX light red
    100: "#FFCBCB",
    200: "#F9A4A4",
    300: "#EC7878",
    400: "#D54D4D",
    500: "#B72D2D", // ReX main red
    600: "#941C1C",
    700: "#711212",
    800: "#4C0A0A",
    900: "#260404",
  },
};
